// Loaded by each player-facing page (index, story, play, Studio, My stories, create, workshop).
import { startAnalytics } from './posthog.js'

startAnalytics()
